import StatsBox from "./StatsPage/StatsBox.js";
import ResultInfoText from "./ResultsTable/ResultInfoText.js";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


function ContactBox() {
  return (
    <div className="contact-box">
      <h5>Contact</h5>
      <p>
        For any questions, suggestions or comments, please contact us at:</p>
        <ul>
          <li><FontAwesomeIcon icon={faEnvelope}/>  engst@uochb.cas.cz</li>
          <li><FontAwesomeIcon icon={faEnvelope}/>  tomas.pluskal@uochb.cas.cz</li>
        </ul>
    </div>
  );
}

export default ContactBox;
